<template>
  <Select
    v-model="hatSize"
    :options="hatSizeOptions"
    option-label="label"
    option-value="value"
    placeholder="Select size"
    class="w-full"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import Fraction from "fraction.js";
import Select from "primevue/select";

const props = defineProps<{
  min: number;
  max: number;
}>();

const hatSize = defineModel<number | null>();

const hatSizeOptions = computed(() => {
  const minFraction = new Fraction(props.min);
  const maxFraction = new Fraction(props.max);

  const options: { label: string; value: number }[] = [];
  const increment = new Fraction(1, 8);
  let size = minFraction;
  const maxSize = maxFraction;

  while (size.compare(maxSize) <= 0) {
    const value = size.valueOf();
    options.push({
      label: `${size.toFraction(true)}"`,
      value: value,
    });
    size = size.add(increment);
  }
  return options;
});
</script>
